module.exports = __webpack_public_path__ + "static/media/spacecraft.7835ca44.png";